import { motion } from "framer-motion";
import { MessageCircle, Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PRODUCTS, waWithMessage } from "./data";

const BADGES = ["Eco Friendly", "Carbon Natural", "No Adhesive · No Sulphur", "High Calorific Value"];

export const Products = () => (
  <section id="products" data-testid="products-section" className="relative bg-[#071009] py-20 lg:py-32">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>The Lineup</Eyebrow>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="products-heading">
          Our Products — Three Grades, One Standard of Purity
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3">
        {PRODUCTS.map((p, i) => (
          <motion.article
            key={p.code}
            data-testid={`product-card-${p.code.toLowerCase().replace(" ", "-")}`}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -8 }}
            className="group overflow-hidden rounded-2xl border border-emerald-500/15 bg-[#0B150F] transition-colors duration-300 hover:border-emerald-500/45"
          >
            <div className="relative overflow-hidden">
              <img
                src={p.image}
                alt={`${p.code} ${p.size} bio pellets by KARM INDUSTRIES`}
                className="aspect-[3/2] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B150F] via-transparent to-transparent" />
              <span className="absolute left-4 top-4 rounded-full bg-[#050B07]/80 px-4 py-1.5 font-mono2 text-[11px] font-bold uppercase tracking-widest text-emerald-300 backdrop-blur-sm">
                {p.tag}
              </span>
              <span className="absolute bottom-4 right-4 rounded-full bg-emerald-500 px-4 py-2 font-display text-sm font-extrabold text-[#050B07]" data-testid={`product-price-${p.code.toLowerCase().replace(" ", "-")}`}>
                {p.price} / Ton
              </span>
            </div>

            <div className="p-7">
              <h3 className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
                {p.code}
                <span className="ml-3 font-mono2 text-sm font-bold uppercase tracking-widest text-emerald-400">{p.size}</span>
              </h3>
              <p className="mt-2 text-sm text-slate-400">{p.best}</p>

              <dl className="mt-6 divide-y divide-emerald-900/30 border-y border-emerald-900/30">
                {p.specs.map(([k, v]) => (
                  <div key={k} className="flex items-center justify-between py-2.5">
                    <dt className="text-xs uppercase tracking-wider text-slate-500">{k}</dt>
                    <dd className="font-mono2 text-sm font-bold text-emerald-300">{v}</dd>
                  </div>
                ))}
              </dl>

              <div className="mt-5 flex flex-wrap gap-2">
                {BADGES.map((b) => (
                  <span key={b} className="flex items-center gap-1.5 rounded-full bg-emerald-950/60 px-3 py-1 text-[11px] font-medium text-emerald-200">
                    <Check className="h-3 w-3 text-emerald-400" /> {b}
                  </span>
                ))}
              </div>

              <a
                href={waWithMessage(`Hello KARM INDUSTRIES, I'm interested in ${p.code} (${p.size} Bio Pellets — ${p.price}/Ton). Please share a quotation.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`product-enquire-${p.code.toLowerCase().replace(" ", "-")}`}
                className="mt-7 flex items-center justify-center gap-2 rounded-full bg-emerald-500 py-3.5 text-xs font-bold uppercase tracking-widest text-[#050B07] transition-all duration-300 hover:bg-emerald-400 hover:shadow-[0_0_28px_rgba(16,185,129,0.4)]"
              >
                <MessageCircle className="h-4 w-4" /> Get {p.code} Quote
              </a>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
